import axios from '../services/axios';

import { HINTS_URL, RESTAURANT_ID } from '../config/api';

import { getValidTokenKiosk, authHeader } from "../services/getValidToken";

import * as signalR from '@aspnet/signalr';

import store from '../store';

import { getPotsApiConfig } from '../selectors/configSelectors';
import { getPaymentKioskSettings } from '../selectors/paymentKioskSelectors';
import { setHubConnectionState, setPaymentKioskSettings, responseIdScan } from '../reducers/paymentKioskReducer';

import { isEmpty } from '../helpers/paymentKiosk';
import { toISO8601 } from '../helpers/date';

import {
  CASH_HANDLING_ACCOUNT_PREFIX,
  CASH_HANDLING_UNTRACKED_ACCOUNT,
  CASH_HANDLING_TRANSACTION_CREATOR_EMAIL
} from '../config/paymentKiosk';

import { LOGIN_MODE, HUB_CONNECTION_STATE } from '../const/paymentKiosk';

export const paymentKioskHub = (() => {
  const RECONNECT_DELAY = 2500;

  let reconnectCallbackTimeoutId = null;

  let hubConnection = null;

  const startConnection = () => {
    hubConnection
      .start()
      .then(() => {
        const paymentKioskId = getPaymentKioskId();

        if (!isEmpty(paymentKioskId)) {
          hubConnection.invoke('Join', paymentKioskId, 'UserInterface');

          store.dispatch(setHubConnectionState(HUB_CONNECTION_STATE.CONNECTED));
        }
      })
      .catch((err) => {
        console.error(err);

        store.dispatch(setHubConnectionState(HUB_CONNECTION_STATE.DISCONNECTED));

        if (reconnectCallbackTimeoutId !== null) {
          clearTimeout(reconnectCallbackTimeoutId);
        }

        reconnectCallbackTimeoutId = setTimeout(function () {
          startConnection();
        }, RECONNECT_DELAY);
      });
  }

  const initializeHub = () => {
    if (hubConnection) {
      return;
    }

    store.dispatch(setHubConnectionState(HUB_CONNECTION_STATE.DISCONNECTED));

    const potsConfig = getPotsConfig();

    hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${potsConfig.url}/messageHub`, {
        accessTokenFactory: () => potsConfig.token
      })
      .configureLogging(signalR.LogLevel.Warning)
      .build();

    hubConnection.onclose(() => {
      store.dispatch(setHubConnectionState(HUB_CONNECTION_STATE.DISCONNECTED));

      if (reconnectCallbackTimeoutId !== null) {
        clearTimeout(reconnectCallbackTimeoutId);
      }

      reconnectCallbackTimeoutId = setTimeout(function () {
        startConnection();
      }, RECONNECT_DELAY);
    });

    hubConnection.on('ProcessDriverLicense', scanResponse => {
      store.dispatch(responseIdScan(scanResponse));
    })

    startConnection();
  }

  const invokeMethod = (...invokeArguments) => {
    hubConnection.invoke.apply(hubConnection, invokeArguments);
  }

  return {
    initializeHub: initializeHub,
    invokeMethod: invokeMethod
  };
})();

export const getOrderId = () => new Date().getTime();
export const getTransactionTimestamp = () => toISO8601(new Date());

export function getPotsConfig() {
  const state = store.getState();

  return getPotsApiConfig(state);
}

export function getPaymentKioskId() {
  const state = store.getState();

  const paymentKioskSettings = getPaymentKioskSettings(state);

  return paymentKioskSettings.kioskId;
}

export function getPaymentKioskLoginMode() {
  const state = store.getState();

  const paymentKioskSettings = getPaymentKioskSettings(state);

  return paymentKioskSettings.loginMode;
}

export const initPaymentKioskSettings = (urlAddress) => {
  const searchParams = (new URL(urlAddress)).searchParams;

  const kioskId = searchParams.get('kioskId');
  const loginMode = searchParams.get('loginMode') || '';

  var parsedLoginMode;

  switch (loginMode.toUpperCase()) {
    case 'WITH_REDIRECT':
      parsedLoginMode = LOGIN_MODE.WITH_REDIRECT;
      break;

    default:
      parsedLoginMode = LOGIN_MODE.DEFAULT;
      break;
  }

  console.info(`Setting kioskId to "${kioskId}", login mode to "${parsedLoginMode}"`);

  store.dispatch(setPaymentKioskSettings({
    kioskId: kioskId,
    loginMode: parsedLoginMode
  }));
};

export async function getCashHandlingAccounts() {
  const paymentKioskId = getPaymentKioskId();

  const kioskToken = await getValidTokenKiosk();

  return axios
    .create()
    .get(
      `${HINTS_URL}/HintsService/v1.0/rest/account/restaurant/${RESTAURANT_ID}/getall`,
      authHeader(kioskToken)
    )
    .then((availableAccounts) => {
      return availableAccounts
        .data
        .data
        .filter(a => a.name === CASH_HANDLING_UNTRACKED_ACCOUNT || a.name.indexOf(`${CASH_HANDLING_ACCOUNT_PREFIX}-${paymentKioskId}-`) === 0);
    });
}

export async function getCashHandlingUsers() {
  const kioskToken = await getValidTokenKiosk();

  return axios
    .create()
    .get(
      `${HINTS_URL}/HintsService/v1.0/rest/portaluser/restaurant/${RESTAURANT_ID}/list`,
      authHeader(kioskToken)
    )
    .then((availableUsers) => {
      return availableUsers
        .data
        .data
        .filter(a => a.email === CASH_HANDLING_TRANSACTION_CREATOR_EMAIL);
    });
}



// WEBPACK FOOTER //
// ./src/services/paymentKiosk.js